let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5NG15")).then(() => parcelRequire('byL9G'));